import { BusinessDownloadConfig } from '../types';
import mobileConfig from './mobile';
import pcConfig from './pc';
import consoleConfig from './console';
import mobileDetailsConfig from './mobileDetails';
import pcDetailsConfig from './pcDetails';
import combineDetailsConfig from './combineDetails';
import pcConsoleTopChartsConfig from './pcConsoleTopCharts';
import consoleDetailsConfig from './consoleDetails';
import companies from './companies';
import followingConfig from './following';
import marketProfileConfig from './marketProfile';
import compare from './compare';
import genreProfile from './genreProfile';
import streaming from './streaming';
import pcConsole from './pcConsole';
import pcConsoleDetails from './pcConoleDetails';
import mobileBenchmark from './mobileBenchmark';
import overlapMobileGames from './overlapMobileGames';
import studio from './studio';
import trueAllDataDownloadExcel from './trueAllDataDownloadExcel';
import casualGamesHub from './casualGamesHub';
import studioHubCompetitors from './studioHubCompetitors';

export const DownLoadConfig: BusinessDownloadConfig = {
  ...mobileConfig, // mobile
  ...pcConfig, // pc
  ...consoleConfig, // console
  ...mobileDetailsConfig, // mobile详情页
  ...pcDetailsConfig, // pc详情页
  ...combineDetailsConfig, // combine详情页
  ...pcConsoleTopChartsConfig, // pcConsole榜单页
  ...consoleDetailsConfig, // console详情页
  ...companies, // 公司榜单页
  ...marketProfileConfig, // marketProfileStats
  ...followingConfig, // following页面
  ...compare, // compare页面，目前只有mobile compare,
  ...genreProfile, // GenreProfile
  ...streaming,
  ...pcConsole, // pcConsole联合id
  ...pcConsoleDetails, // TO do待合并
  ...mobileBenchmark,
  ...overlapMobileGames, // overlaps MobileGames
  ...studio, // studio
  ...trueAllDataDownloadExcel, // 真数下载
  ...casualGamesHub,
  ...studioHubCompetitors, // Studio Hub Competitors 页面下载配置
} as any;
